@use "../../../../styles/colors";

:global {
  body[class*="theme-"].theme {
    :local {
      .infoIcon {
        color: colors.$mmc-soft-slate;
      }
    }
  }
}
